import { EntityStatus } from '@taxora-api-models';

export class LoadClients {
  static readonly type = '[ClientsState] LoadClients';
  constructor(
    public params: {
      organizationId: number;
      search?: string;
      status?: EntityStatus;
      page?: number;
      limit?: number;
    },
  ) {}
}

export class ResetClients {
  static readonly type = '[ClientsState] ResetClients';
}

export class LoadClientDetail {
  static readonly type = '[ClientsState] LoadClientDetail';
  constructor(public id: number) {}
}

export class ResetClientDetail {
  static readonly type = '[ClientsState] ResetClientDetail';
}

export class LoadCancellationRequests {
  static readonly type = '[ClientsState] LoadCancellationRequests';
  constructor(public organizationId: number) {}
}

export class TerminateCollaboration {
  static readonly type = '[ClientsState] TerminateCollaboration';
  constructor(public id: number) {}
}

export class AcceptCancellationRequest {
  static readonly type = '[ClientsState] AcceptCancellationRequest';
  constructor(public id: number) {}
}

export class RejectCancellationRequest {
  static readonly type = '[ClientsState] RejectCancellationRequest';
  constructor(
    public id: number,
    public message?: string,
  ) {}
}
